import { isFRQ } from 'legacy-src/utility/progressHelpers';

/**
 * This function returns the behavior of PE/de-PE-fied quiz.
 * @param {Boolean} isPracticeExam - DB flag for being a PE.
 * @param {Array} questions - The list of quiz' questions.
 * @returns `true` if the PE is still a PE, `false` if the PE is de-PE-fied.
 * */
const hasPracticeExamBehavior = (isPracticeExam, questions) => {
  return isPracticeExam && !questions?.every(isFRQ);
};

export default hasPracticeExamBehavior;
